import { _validate_null_ } from "./validate";
import qs from "qs";

// 表单序列化
export const serialize = (data) => {
  const list = [];
  Object.keys(data).forEach((ele) => {
    list.push(`${ele}=${data[ele]}`);
  });
  return list.join("&");
};

export function cookie_get(name) {
  var cookies = document.cookie.split(";");
  name = name + "=";
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(name) == 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }

  return "";
}

// 不知道为啥 localStorage 或 sessionStorage 里存的 redirect_url 似乎会丢失 这里给个默认值
var redirect_url_default = function () {
  var params = qs.parse(location.search.replace(/^\?/, ""))
  if ("login-admin" == params.from) {
    return "/v4/admin"
  }

  if ('v2.rongchuangfuli.com' == location.host) {
    return "/web/index-v3"
  }

  return "/v6/home"
}

export function go_redirect_url() {
  var redirect_url = localStorage.getItem("budo.v2_redirect_url") + ""
  budo_log.info("#26 go_redirect_url, redirect_url=", redirect_url)

  // 移除
  localStorage.removeItem("budo.v2_redirect_url")

  if (!redirect_url ||
    redirect_url.indexOf("null") > -1 ||
    redirect_url.indexOf("login-success") > -1 ||
    redirect_url.indexOf("CardLogin") > -1 ||
    redirect_url.indexOf("/login") > -1 // v4/login-admin
  ) {
    redirect_url = redirect_url_default()
  }

  location.href = redirect_url;
}

export function $user_index_bg_1() {
  if (
    location.href.includes("cdhuanying.com") ||
    location.href.includes("04mm.cn")
  ) {
    // D05637
    return "background: linear-gradient(50deg, #D05637 , #b9e7f1);";
  }

  return "background: linear-gradient(50deg, #0758C4 , #b9e7f1);";
}

export function $user_index_bg_2() {
  if (
    location.href.includes("cdhuanying.com") ||
    location.href.includes("04mm.cn")
  ) {
    return "background: linear-gradient(60deg, #0758C4 , #D05637);";
  }

  return "background: linear-gradient(60deg, #0758C4 , #0d3a46);";
}
